import React, { useState,useEffect } from 'react';
import './css/eventform.css';
import { useNavigate } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import ConfirmDialog from './components/ConfirmDialog.js';
import { Button, Dialog, DialogContent, DialogActions } from '@mui/material';
import { API_URL_BASE } from './config';

const CompanySettingsForm = () => {
	const [token, setToken] = useState('');
	const [message, setMessage] = useState('');
	const [emailError, setEmailError] = useState('');
	const [mobileError, setMobileError] = useState('');	
	const [companyDetails, setCompanyDetails] = useState('');
	const [showDetails, setShowDetails] = useState('false');
	const [isEditable, setIsEditable] = useState(false);
	const [loading, setLoading] = useState(true);
	const [open, setOpen] = useState(false);
	const navigate = useNavigate();
	const [dialogmessage,setDialogMessage] = useState('');
	const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
	const validateMobile = (val) => /^(?:06\d{8}|\+316\d{8})$/.test(val);

	
    const [formData, setFormData] = useState({
        compName: '',
		cocNo: '',
		VATNo : '',
        accountName: '',
        accountNo: '',
        contactemail: '',
		contactno : ''
    });
	
	// Step 1: Set token from localStorage
	useEffect(() => {
	  const storedToken = localStorage.getItem('token');
	  if (storedToken) {
		setToken(storedToken);
	  } else {
	    // Optional: redirect to login or show fallback
	    console.warn("No token found in localStorage");
		navigate("/");	 
	  }
	}, []);
	
	// Step 2: Fetch company details when token is set
	 useEffect(() => {
	   if (!token) return; // Don't run if token is not ready
	   
	   console.log("token - " + token);

	   fetch(API_URL_BASE + '/ticket.json', {
	     method: 'POST',
	     headers: {
	       'Content-Type': 'application/json',
	     },
	     body: JSON.stringify({
	       fetchcompany: {
	           token: token
	       }
	     }),
	   })
	     .then((res) => {
	       if (!res.ok) throw new Error(`Server error: ${res.status}`);
	       return res.json();
	     })
	     .then((result) => {
			console.log("Fetched detail ", result);
						
			setFormData({
			           compName: result.company.name || '',
			           cocNo: result.company.cocno || '',
			           VATNo: result.company.vatno || '',
			           accountName: result.company.accountname || '',
			           accountNo: result.company.accountno || '',
			           contactemail: result.company.email || '',
			           contactno: result.company.contactno || ''
			         });
			 // After save, disable editing again
			 setIsEditable(false);	
			 localStorage.setItem('compName',result.company.name);		
			
	     })
	     .catch((err) => {
	       console.error("Fetch error:", err);
		   navigate("/");
	     })
	     .finally(() => {
			setLoading(false);
	     });
	 }, [token]); // 🔁 Runs whenever token or refreshkey is updated

	 const handleOkClick = () => {
	   setOpen(false); // Close the dialog
	   window.location.reload();
	 };
	 
	const handleChange = (e) => {
	  const { name, value, type, checked } = e.target;

	  setFormData((prevFormData) => ({
	    ...prevFormData,
	    [name]: type === 'checkbox' ? checked : value, // for both input and radio, value works the same
	  }));
	};


	const handleSubmit =  async (e) => {
		console.log(formData);
	    e.preventDefault();
		try {
		const response = await fetch(API_URL_BASE + '/ticket.json', {
					    	method: 'POST',
					    	headers: {
					      	'Content-Type': 'application/json',
					    	},
					    	body: JSON.stringify(					{
								savecompany : {
									token: token,
									company  : {	
										name: formData.compName,
										cocno: formData.cocNo,
										vatno: formData.VATNo,
										accountname : formData.accountName,
										accountno:formData.accountNo,
										email:formData.contactemail,
										contactno:formData.contactno
									}}
							  })
					  	});
						

		// Check if fetch succeeded (status not blocked)
		if (!response.ok) {
		  throw new Error(`Server error: ${response.status}`);
		}

		const result = await response.json();
		console.log(result);
		setMessage(result.message);
		
		if (result && result.statusFlag == true) {
		  //return result.message; // Return eventId to caller
		  setIsEditable(false); // switch back to view mode
		} else {
		  throw new Error("Creating/updating company details failed..");
		}
		
		} catch(e){
			setMessage(e.message || " An unexpected error occurred with adding company details!!");
		}	    
	};


    return (
	<div>		
			<p className="error-text">{message}</p>
			<Dialog open={open} onClose={handleOkClick}>
			  <DialogContent>
			   	{dialogmessage}
			  </DialogContent>
			  <DialogActions>
			    <Button onClick={() => {
							setOpen(false); // Close the dialog 
							window.location.reload();}} autoFocus>
			      OK
			    </Button>
			  </DialogActions>
			</Dialog>
				<form onSubmit={handleSubmit} className="event-form">
						
			<div className="event-form-container">
			<h2>Company Profile </h2>

                <label className="event-form">Company Name<span className="required-asterisk">*</span></label>
                <input type="text" name="compName" value={formData.compName} onChange={handleChange} disabled={!isEditable} />
				
				<label className="event-form">COC Number (Chamber of Commerce)</label>
				<input type="number" name="cocNo" value={formData.cocNo} onChange={handleChange} disabled={!isEditable} />
				
				
				<label className="event-form">VAT Number </label>
				<input type="text" name="VATNo" value={formData.VATNo} onChange={handleChange}  disabled={!isEditable}/>

				
                <label className="event-form">Bank Account Name</label>
                <input type="text" name="accountName" value={formData.accountName} onChange={handleChange}  disabled={!isEditable}/>			
							
				
				<label className="event-form">Bank Account Number</label>
				<input type="text" name="accountNo" value={formData.accountNo} onChange={handleChange}  disabled={!isEditable}/>			
				
				<label className="event-form">Contact Email<span className="required-asterisk">*</span></label>
				<input type="email" name="contactemail" value={formData.contactemail} 
				disabled={!isEditable}
				placeholder="Contact email address for any payment related queries"
				onChange={(e) => {
				    handleChange(e);
				    if (!validateEmail(e.target.value)) {
				      setEmailError("Please enter a valid email address");
				    } else {
				      setEmailError("");
				    }
				  }} />
				{emailError && <p className="error-text">{emailError}</p>}
				
				<label className="event-form">Contact Mobile<span className="required-asterisk">*</span></label>
				<input type="tel" name="contactno" value={formData.contactno} 
				placeholder="Contact mobile number for payment related queries."  disabled={!isEditable}
				onChange={(e) => {
					handleChange(e);
					if (!validateMobile(e.target.value)) {
						setMobileError("Please enter a valid mobile no");
					} else {
						setMobileError("");
					}
					}} />
				{mobileError && <p className="error-text">{mobileError}</p>}
				
				
				 { isEditable ? (
					<button type="submit" className="submit-btn">SAVE</button>
				  ) : (
					<button type="toggle" className="submit-btn" onClick={(e) => {e.preventDefault();setIsEditable(true);}}>EDIT</button>
				  )}

			</div>
			</form>
			
        </div>
    );
}


export default CompanySettingsForm;
